module.exports = __webpack_public_path__ + "static/media/student-summary-teacher.22da96e1.png";